var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "crud crud-edit" },
    [
      !_vm.CalledByShortCut
        ? _c(
            "actionBarComponent",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.naturezaoperacao.edit_vue_html.naturezaOpEdit"
                ),
                slots: 2,
              },
              on: { onSave: _vm.save },
              scopedSlots: _vm._u([
                {
                  key: "buttonSlot1",
                  fn: function (ref) {
                    var open = ref.open
                    return _vm.modelId > 0
                      ? _c(
                          "div",
                          {
                            attrs: {
                              title: _vm.$t("__.ts.historicoAlteracoes"),
                            },
                            on: {
                              click: function ($event) {
                                open(
                                  1,
                                  _vm.$t("__.ts.historicoAlteracoes"),
                                  "lg-modal"
                                )
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-history",
                              attrs: { "aria-hidden": "true" },
                            }),
                          ]
                        )
                      : _vm._e()
                  },
                },
              ]),
            },
            [
              _c(
                "div",
                { attrs: { slot: "modalSlot1" }, slot: "modalSlot1" },
                [
                  _c("logEntidadeComponent", {
                    attrs: {
                      registroId: _vm.modelId,
                      entidade: _vm.tipoLogEntidadeNaturezaOperacao,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "form",
        {
          attrs: { novalidate: "novalidate" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.save()
            },
          },
        },
        [
          _c("fieldset", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-10" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("descricao"),
                        expression: "errors.first('descricao')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "descricao",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.descricao"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        { name: "focus", rawName: "v-focus" },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.descricao,
                          expression: "model.descricao",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:256",
                          expression: "'required|max:256'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        id: "descricao",
                        name: "descricao",
                      },
                      domProps: { value: _vm.model.descricao },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "descricao", $event.target.value)
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("ativo"),
                        expression: "errors.first('ativo')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$t("__.ts.ativo")) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "ativo", name: "ativo" },
                      model: {
                        value: _vm.model.ativo,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "ativo", $$v)
                        },
                        expression: "model.ativo",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("codigo"),
                        expression: "errors.first('codigo')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "codigo",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.codigo"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.codigo,
                          expression: "model.codigo",
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|maior_que_zero",
                          expression: "'required|maior_que_zero'",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        id: "codigo",
                        name: "codigo",
                      },
                      domProps: { value: _vm.model.codigo },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "codigo", $event.target.value)
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-6" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("tipoMovimentacao"),
                        expression: "errors.first('tipoMovimentacao')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "tipoMovimentacao",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.tipoMovimento"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "tipoMovimentacao",
                        name: "tipoMovimentacao",
                        data: _vm.tiposMovimentacaoOptions,
                        searchable: false,
                      },
                      model: {
                        value: _vm.model.tipoMovimentacao,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "tipoMovimentacao", $$v)
                        },
                        expression: "model.tipoMovimentacao",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("dentroEstado"),
                        expression: "errors.first('dentroEstado')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.dentroEstado"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "dentroEstado", name: "dentroEstado" },
                      model: {
                        value: _vm.model.dentroEstado,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "dentroEstado", $$v)
                        },
                        expression: "model.dentroEstado",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("movimentaEstoque"),
                        expression: "errors.first('movimentaEstoque')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.movimentaEstq"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("data-tooltip-component", {
                      attrs: {
                        text: _vm.$t(
                          "__.Crud.naturezaoperacao.edit_vue_html.movimentaEstqToolTip"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "movimentaEstoque",
                        name: "movimentaEstoque",
                      },
                      model: {
                        value: _vm.model.movimentaEstoque,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "movimentaEstoque", $$v)
                        },
                        expression: "model.movimentaEstoque",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("usaConfiguracaoFiscal"),
                        expression: "errors.first('usaConfiguracaoFiscal')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.usaConfiguracaoFiscal"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: {
                        id: "usaConfiguracaoFiscal",
                        name: "usaConfiguracaoFiscal",
                      },
                      model: {
                        value: _vm.model.usaConfiguracaoFiscal,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "usaConfiguracaoFiscal", $$v)
                        },
                        expression: "model.usaConfiguracaoFiscal",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.transferencia"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "transferencia", name: "transferencia" },
                      model: {
                        value: _vm.model.transferencia,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "transferencia", $$v)
                        },
                        expression: "model.transferencia",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("simplesRemessa"),
                        expression: "errors.first('simplesRemessa')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.simplesRemessa"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "simplesRemessa", name: "simplesRemessa" },
                      model: {
                        value: _vm.model.simplesRemessa,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "simplesRemessa", $$v)
                        },
                        expression: "model.simplesRemessa",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("importacao"),
                        expression: "errors.first('importacao')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      { staticClass: "control-label", attrs: { for: "ativo" } },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.importacao"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("data-tooltip-component", {
                      attrs: {
                        text: _vm.$t(
                          "__.Crud.naturezaoperacao.edit_vue_html.importacaoToolTip"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "importacao", name: "importacao" },
                      model: {
                        value: _vm.model.importacao,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "importacao", $$v)
                        },
                        expression: "model.importacao",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "cstICMS" },
                          },
                          [_vm._v("Situação tributária ICMS")]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "cstICMS",
                            name: "cstICMS",
                            data: _vm.cstICMSOptions,
                          },
                          model: {
                            value: _vm.model.cstICMS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cstICMS", $$v)
                            },
                            expression: "model.cstICMS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "aliquotaICMS" },
                          },
                          [_vm._v("Alíquota ICMS")]
                        ),
                        _vm._v(" "),
                        _c("decimal-com-sinal-custom-component", {
                          staticClass: "form-control",
                          attrs: {
                            signal: "%",
                            id: "aliquotaICMS",
                            name: "aliquotaICMS",
                          },
                          model: {
                            value: _vm.model.aliquotaICMS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "aliquotaICMS", $$v)
                            },
                            expression: "model.aliquotaICMS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "codigoBeneficio" },
                        },
                        [_vm._v("Código Benefício Fiscal")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.codigoBeneficio,
                            expression: "model.codigoBeneficio",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "codigoBeneficio",
                          name: "codigoBeneficio",
                        },
                        domProps: { value: _vm.model.codigoBeneficio },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model,
                              "codigoBeneficio",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "cstPIS" },
                          },
                          [_vm._v("Situação tributária PIS")]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "cstPIS",
                            name: "cstPIS",
                            data: _vm.cstPISCOFINSOptions,
                          },
                          model: {
                            value: _vm.model.cstPIS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cstPIS", $$v)
                            },
                            expression: "model.cstPIS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "aliquotaPIS" },
                          },
                          [_vm._v("Alíquota PIS")]
                        ),
                        _vm._v(" "),
                        _c("decimal-com-sinal-custom-component", {
                          staticClass: "form-control",
                          attrs: {
                            signal: "%",
                            id: "aliquotaPIS",
                            name: "aliquotaPIS",
                          },
                          model: {
                            value: _vm.model.aliquotaPIS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "aliquotaPIS", $$v)
                            },
                            expression: "model.aliquotaPIS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "cstCOFINS" },
                          },
                          [_vm._v("Situação tributária COFINS")]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "cstCOFINS",
                            name: "cstCOFINS",
                            data: _vm.cstPISCOFINSOptions,
                          },
                          model: {
                            value: _vm.model.cstCOFINS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cstCOFINS", $$v)
                            },
                            expression: "model.cstCOFINS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "aliquotaCOFINS" },
                          },
                          [_vm._v("Alíquota COFINS")]
                        ),
                        _vm._v(" "),
                        _c("decimal-com-sinal-custom-component", {
                          staticClass: "form-control",
                          attrs: {
                            id: "aliquotaCOFINS",
                            name: "aliquotaCOFINS",
                            signal: "%",
                          },
                          model: {
                            value: _vm.model.aliquotaCOFINS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "aliquotaCOFINS", $$v)
                            },
                            expression: "model.aliquotaCOFINS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "cstIPI" },
                          },
                          [_vm._v("Situação tributária IPI")]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "cstIPI",
                            name: "cstIPI",
                            data: _vm.cstIPIOptions,
                          },
                          model: {
                            value: _vm.model.cstIPI,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cstIPI", $$v)
                            },
                            expression: "model.cstIPI",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "aliquotaIPI" },
                          },
                          [_vm._v("Alíquota IPI")]
                        ),
                        _vm._v(" "),
                        _c("decimal-com-sinal-custom-component", {
                          staticClass: "form-control",
                          attrs: {
                            signal: "%",
                            id: "aliquotaIPI",
                            name: "aliquotaIPI",
                          },
                          model: {
                            value: _vm.model.aliquotaIPI,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "aliquotaIPI", $$v)
                            },
                            expression: "model.aliquotaIPI",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-6" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "cstIBSCBS" },
                          },
                          [_vm._v("Situação tributária IBS/CBS")]
                        ),
                        _vm._v(" "),
                        _c("combo-component", {
                          attrs: {
                            id: "cstIBSCBS",
                            name: "cstIBSCBS",
                            data: _vm.cstIBSCBSOptions,
                          },
                          model: {
                            value: _vm.model.cstIBSCBS,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "cstIBSCBS", $$v)
                            },
                            expression: "model.cstIBSCBS",
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.model.usaConfiguracaoFiscal
                ? _c("div", { staticClass: "col-sm-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "label",
                        {
                          staticClass: "control-label",
                          attrs: { for: "classificacaoTributaria" },
                        },
                        [_vm._v("Classificação Tributária")]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.model.classificacaoTributaria,
                            expression: "model.classificacaoTributaria",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: {
                          type: "text",
                          id: "classificacaoTributaria",
                          name: "classificacaoTributaria",
                          maxlength: "6",
                          oninput:
                            "this.value = this.value.replace(/[^0-9]/g, '')",
                        },
                        domProps: { value: _vm.model.classificacaoTributaria },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.model,
                              "classificacaoTributaria",
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-10" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("observacao"),
                        expression: "errors.first('observacao')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "observacao" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.observacoes"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("data-tooltip-component", {
                      attrs: {
                        text: _vm.$t(
                          "__.Crud.naturezaoperacao.edit_vue_html.observacaoPadraoTooltip"
                        ),
                      },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.model.observacao,
                          expression: "model.observacao",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        autocomplete: "off",
                        type: "text",
                        id: "observacao",
                        name: "observacao",
                      },
                      domProps: { value: _vm.model.observacao },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.model, "observacao", $event.target.value)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("consumidorFinal"),
                        expression: "errors.first('consumidorFinal')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: { for: "consumidorFinal" },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.naturezaoperacao.edit_vue_html.consumidorFinal"
                              )
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("checkbox-component", {
                      attrs: { id: "consumidorFinal", name: "consumidorFinal" },
                      model: {
                        value: _vm.model.consumidorFinal,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "consumidorFinal", $$v)
                        },
                        expression: "model.consumidorFinal",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.naturezaoperacao.edit_vue_html.observacoesPorUF"
                ),
                collapsed: false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows" }, slot: "rows" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "ufObservacao" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.naturezaoperacao.edit_vue_html.uf"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "ufObservacao",
                              name: "ufObservacao",
                              data: _vm.ufOptions,
                              searchable: true,
                            },
                            model: {
                              value: _vm.ufObservacao,
                              callback: function ($$v) {
                                _vm.ufObservacao = $$v
                              },
                              expression: "ufObservacao",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-sm-6" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "control-label",
                            attrs: { for: "observacaoTexto" },
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "__.Crud.naturezaoperacao.edit_vue_html.observacao"
                                  )
                                ) +
                                "\n                            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.observacaoTexto,
                              expression: "observacaoTexto",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            autocomplete: "off",
                            type: "text",
                            id: "observacaoTexto",
                            name: "observacaoTexto",
                          },
                          domProps: { value: _vm.observacaoTexto },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.observacaoTexto = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("buttonIncluirComponent", {
                    on: { click: _vm.onInclusaoObservacaoUF },
                  }),
                  _vm._v(" "),
                  _c("grid-component", {
                    attrs: {
                      data: _vm.model.observacoes,
                      columns: _vm.gridColumnsObservacoesUF,
                      "show-table-head": false,
                      "show-table-foot": false,
                      "show-edit-item": false,
                      showActionColumn: true,
                    },
                    on: { "remove-item": _vm.onRemoveObservacaoUF },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "fieldset-component",
            {
              attrs: {
                title: _vm.$t(
                  "__.Crud.naturezaoperacao.edit_vue_html.finalidadesEmissaoFieldset"
                ),
                collapsed: false,
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "rows" }, slot: "rows" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-sm-4" }, [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "finalidadeEmissaoPermitidaId" },
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(
                                    _vm.$t(
                                      "__.Crud.naturezaoperacao.edit_vue_html.finalidadeEmissao"
                                    )
                                  ) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("combo-component", {
                            attrs: {
                              id: "finalidadeEmissaoPermitidaId",
                              name: "finalidadeEmissaoPermitidaId",
                              data: _vm.finalidadesEmissaoDisponiveisOptions,
                            },
                            model: {
                              value: _vm.finalidadeEmissaoPermitidaId,
                              callback: function ($$v) {
                                _vm.finalidadeEmissaoPermitidaId = $$v
                              },
                              expression: "finalidadeEmissaoPermitidaId",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("buttonIncluirComponent", {
                    on: { click: _vm.onInclusaoFinalidadeEmissao },
                  }),
                  _vm._v(" "),
                  _c("grid-component", {
                    attrs: {
                      data: _vm.model.finalidadesEmissao,
                      columns: _vm.gridColumnsFinalidadesEmissao,
                      "show-table-head": false,
                      "show-table-foot": false,
                      "show-edit-item": false,
                      showActionColumn: true,
                    },
                    on: { "remove-item": _vm.onRemoveFinalidadeEmissao },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.CalledByShortCut
            ? _c("fieldset", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-sm-12 newbtn" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "submit" },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-save",
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.salvar")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.load()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.limpar")) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.cancel()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("__.Crud.voltar")) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }